import { useEffect, useState } from 'react';
import { Logo } from './Logo';

export function Splash() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setShow(false), 4000);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div
      className={`flex items-center justify-center fixed inset-0 bg-secondary ease-out duration-1000 transition-opacity ${
        show ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
    >
      <Logo className="w-full max-w-4xl mx-12" />
    </div>
  );
}
